import React from 'react';
import Async from 'react-select/lib/Async'
import Highlighter from 'react-highlight-words';
import API from 'fw/system/API'

class Auto extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			className: this._className(),
			value: props.value,
			text: props.text
		};
	}

	// Public API
	setValue = (value) => {
		//this._update(value, this._parse(value), this._format(value));
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._select.focus();
	}

	select = () => {
		this._select.select();
	}

	flag = (status) => {
		if (!status)
			this.setState((prevState) => {
				return { className: prevState.className + " invalid-field" }
			});
		else
			this.setState((prevState) => {
				return { className: prevState.className.replace("invalid-field", "") }
			});
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_handleChange = (item) => {
		const me = this;
		let value = null;
		let label = null;

		if (item !== null) {
			value = item.value;
			label = item.label;
		}

		this.setState({
			value: value,
			text: label
		}, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);

			const status = requiredPassed && validationPassed;

			this.flag(status);
			this.onDirt();

			// Update value field in form
			if (me.props.managed) {
				if (!me.props.label)
					this.props.onFieldChange(value, this.props.name, function () { me.onChange(item); });
				else
					this.props.onFieldAndLabelChange(value, label, me.props.name, this.props.label, function () { me.onChange(item); });
			}
			else {
				this.onChange(item);
			}
		});
	}

	_loader = (query, callback) => {
		const me = this;

		if (query.length < this.props.minLength)
			return callback(null, { options: [] });

		const rq = {
			query: query
		};

		// Get loader options from caller
		const loaderOpts = this.props.loader();

		// Prepare request with query + params
		Object.assign(rq, loaderOpts.params);

		new API().get(loaderOpts.url, rq,
			{
				success: function (response) {
					// Transform C# dictionary into value/label array needed
					var keys = Object.getOwnPropertyNames(response.data.items);
					var values = Object.values(response.data.items);

					var options = keys.map((key, index) => {
						if (me.props.formatter)
							return me.props.formatter(key, values[index]);

						return {
							value: key,
							label: values[index]
						}
					});

					// Return objects
					callback(options);
				}
			},
			{
				block: false
			});
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.disabled !== this.props.disabled
			|| nextState.value !== this.state.value
			|| nextState.className !== this.state.className
		);
	}

	componentWillReceiveProps(nextProps, nextState) {
		this.setState({
			value: nextProps.value,
			text: nextProps.text
		});
	}

	render() {
		let value = {
			value: this.state.value,
			label: this.state.text,
		};

		// So the place holder appears
		if (!this.state.value || this.state.value === "")
			value = null;

		let opts = {
			id: this.props.id,
			name: this.props.name,
			value: this.props.isMulti ? this.state.value : value,
			isMulti: this.props.isMulti || false,
			placeholder: this.props.placeholder,
			autoload: this.props.autoload,
			className: this.state.className,
			onChange: this._handleChange,
			loadOptions: this._loader,
			optionRenderer: this._renderOption,
			isDisabled: this.props.disabled,
			isClearable: true,
			defaultOptions: this.props.defaultOptions,
			noOptionsMessage: function () {
				return "Type to search...";
			},
			formatOptionLabel: function (option, context) {
				return (<Highlighter
					highlightClassName="auto-highlight"
					autoEscape={true}
					searchWords={[context.inputValue, "(Include all index entries)"]}
					textToHighlight={option.label} />);
			},
			menuPlacement: this.props.menuPlacement
		};

		const customStyles = {
			container: (base, state) => {
				if (!state.isDisabled)
					return {
						...base,
						backgroundColor: "transparent"
					}
				else
					return {
						...base,
						backgroundColor: "#eee"
					}
			},
			singleValue: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#555"
			}),
			placeholder: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#AAA"
			}),
			input: (provided, state) => ({
				...provided,
				marginTop: -2,
				margin: 0,
				paddingBottom: 0,
				paddingTop: 0
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				width: 0
			}),
			control: (provided, state) => ({
				...provided,
				minHeight: 34,
				// A fixed height: 34 (single line) clips/overlaps the clear (x) and dropdown (v)
				// indicators against wrapped chips once a multi-select has enough picks to wrap
				// onto a second row (confirmed live in the one-sheet's NAICS picker — currently
				// the only isMulti consumer of this shared control). Single-select never wraps,
				// so its fixed height is unaffected.
				height: state.selectProps.isMulti ? 'auto' : 34,
				// Once the control grows for wrapped chips (above), the default vertical-center
				// alignment puts the indicators next to whichever row lands in the middle of the
				// stack instead of a consistent spot — pin them to the top row instead.
				alignItems: state.selectProps.isMulti ? 'flex-start' : provided.alignItems,
				boxShadow: 0,
				borderRadius: 0
			}),
			indicatorsContainer: (provided, state) => ({
				...provided,
				cursor: 'pointer',
				// alignItems: flex-start on control (above) doesn't stop this child from
				// stretching to the full (now-multi-row) height on its own — confirmed live via
				// getBoundingClientRect that it was stretching to match the wrapped value
				// container's full height rather than sizing to its own icon content. alignSelf
				// on the child itself is what actually overrides that.
				alignSelf: state.selectProps.isMulti ? 'flex-start' : provided.alignSelf,
				paddingTop: state.selectProps.isMulti ? 4 : provided.paddingTop
			}),
			menu: (provided, state) => ({
				...provided,
				marginTop: 0,
				zIndex: "999 !important"
			}),
			noOptionsMessage: (provided, state) => ({
				...provided,
				marginLeft: 0,
				height: 20,
				padding: 0,
				marging: 0
			}),
			dropdownIndicator: (base, state) => ({
				...base,
				width: '30px'
			}),
			clearIndicator: (base, state) => ({
				...base,
				width: '30px',
				marginRight: '-15px'
			}),
			menuContainerStyle: () => ({
				zIndex: "999"
			})
		}

		return (
			<Async {...opts}
				styles={customStyles}
				onInputChange={
					(inputValue) => {
						this._inputValue = inputValue;
						return (inputValue.length <= this.props.maxLength ? inputValue : inputValue.substr(0, this.props.maxLength))
					}
				}
				ref={(select) => { this._select = select; }} />)
	}
}

Auto.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false,
	autoload: true,
	minLength: 2,
	maxLength: 20
};

export default Auto;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/auto/Auto.js